import type { ReactNode } from 'react'

import { useAccessTokenRoles } from '@b-stock/fe-core/bstock-next/components'
import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import { Banner, FormattedMessage, Link } from '@b-stock/fe-core/bstock-react'

import { FeatureFlags } from '@/helpers/featureFlags'
import { myAccountSettingsBase } from '@/helpers/myAccountNav'

const ns = 'Offerings.Details.offeringStatusBanner.noPermissions'

export const PotentialNoPermissionsBanner = ({
  isListingIndexed,
}: {
  isListingIndexed: boolean
}) => {
  const accountRoles = useAccessTokenRoles()
  const myAccountHpNav = useFlag(FeatureFlags.MY_ACCOUNT_HP_NAV)

  if (accountRoles?.buyer === 'INTENDED' && isListingIndexed) {
    return (
      <Banner title={<FormattedMessage id={`${ns}.title`} />} type="warning">
        <div>
          <FormattedMessage
            id={`${ns}.message`}
            values={{
              link: (content: ReactNode) => (
                <Link
                  href={`${myAccountSettingsBase(myAccountHpNav)}/business-profile`}
                >
                  {content}
                </Link>
              ),
            }}
          />
        </div>
      </Banner>
    )
  }

  return null
}
